import { useState } from 'react';
import { Avatar, Button, Typography } from 'antd';
import { useGlobal } from 'src/contexts/GlobalContext';

import { useGetCurrentUser } from '@/hooks/api/useUsersEndpoint';
import { UserOutlined } from '@ant-design/icons';

import SidebarMobile from '../Sidebar/SidebarMobile';
import { Header } from './AppHeader.styled';
import ClientSwitcher from '../ClientSwitcher/ClientSwitcher';
import { FlexGap16 } from '../CommonStyledComponents/CommonStyledComponents.styled';
import UserProfile from '../UserProfile/UserProfile';
import MobileUserProfile from '../UserProfile/MobileUserProfile';
import NotificationPopover from './components/NotificationPopover';
import { useAuth } from 'src/contexts/AuthContext';

export const AppHeader = () => {
  const { isDesktop } = useGlobal();
  const { data: userData, isSuccess } = useGetCurrentUser();
  const { permissions } = useAuth();

  const [isUserProfileModalVisible, setIsUserProfileModalVisible] = useState(false);

  const fullName = isSuccess ? `${userData?.firstName} ${userData?.lastName}` : '';

  const toggleUserProfileModal = () => setIsUserProfileModalVisible((prev) => !prev);

  return (
    <Header>
      {!isDesktop ? <SidebarMobile /> : null}
      <ClientSwitcher />
      <FlexGap16 align="center">
        {permissions.includes('alert:reader') || permissions.includes('alert:manager') ? <NotificationPopover /> : null}

        {isDesktop ? <Typography.Text>{fullName}</Typography.Text> : null}
        {isDesktop ? (
          <UserProfile visible={isUserProfileModalVisible} toggleUserProfile={toggleUserProfileModal} />
        ) : (
          <>
            <Button data-testid="profile-btn" shape="circle" onClick={toggleUserProfileModal}>
              <Avatar icon={<UserOutlined />} />
            </Button>
            <MobileUserProfile drawerVisible={isUserProfileModalVisible} toggleDrawer={toggleUserProfileModal} />
          </>
        )}
      </FlexGap16>
    </Header>
  );
};
